export default () => {
  // eslint-disable-next-line no-console
  if (window.Cypress) {
    console.log('Accessed platform through Cypress Test Suite: ', window.Cypress);
  }
  return !!(window.Cypress);
};
